import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ChevronDownIcon } from "lucide-react";
interface AccordionProps {
  emoji?: string;
  title: string;
  badge?: string;
  defaultOpen?: boolean;
  accent?: "teal" | "amber";
  children: React.ReactNode;
}
export function Accordion({
  emoji,
  title,
  badge,
  defaultOpen = false,
  accent = "teal",
  children
}: AccordionProps) {
  const [open, setOpen] = useState(defaultOpen);
  const badgeColor = accent === "amber" ? "bg-amber-100 text-amber-700" : "bg-teal-100 text-teal-700";
  return <div className="overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm" data-id="element-17" data-mp="2w4x6bzsj3h8u">
      <button type="button" onClick={() => setOpen(v => !v)} aria-expanded={open} className="flex w-full items-center gap-3 px-4 py-4 text-left" data-id="element-18" data-mp="2s2ipfl8f6rk7">
        {emoji && <span className="text-xl leading-none" data-id="element-19" data-mp="xpj030e8mizq">{emoji}</span>}
        <span className="flex-1 font-display text-[15px] font-bold leading-snug text-slate-800" data-id="element-20" data-mp="xr3zb3bhyq3x">
          {title}
        </span>
        {badge && <span className={`rounded-full px-2.5 py-0.5 text-xs font-bold ${badgeColor}`} data-id="element-21" data-mp="3l48fin5kbrnr">
            {badge}
          </span>}
        <ChevronDownIcon className={`h-5 w-5 shrink-0 text-slate-400 transition-transform duration-200 ${open ? "rotate-180" : ""}`} data-id="element-22" data-mp="3q0yut89jmj84" />
      </button>
      <AnimatePresence initial={false} data-id="element-23" data-mp="3m5sdtj336yl">
        {open && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: "auto",
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.25,
        ease: "easeInOut"
      }} className="overflow-hidden" data-id="element-24" data-mp="7niwnz6j323e">
            <div className="border-t border-slate-100 px-4 py-3" data-id="element-25" data-mp="2ef05les7wc8s">{children}</div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}